/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
// import { useSelector } from 'react-redux';
// import { useEffect } from 'react';
import { useEffectOnce } from '@/hooks';
import { useEffect } from 'react';
import queryString from 'query-string';
import CloseIcon from '@mui/icons-material/Close';
import Skeleton from '@mui/material/Skeleton';
// import Typography from '@mui/material/Typography';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import {
  BPReviewPanel,
  ReviewItemList, RAReviewPanel, SeelEmail,
} from '@components';
import {
  Tabs, Tab, Stack, Button, Stepper, Step, StepLabel, StepContent,
} from '@mui/material';
import { ClaimType } from '@constants';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import classes from './index.module.css';
import useFeedback from './hooks';
import Loading from './loading';
import { isUserMobile } from '../../utils';

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const statusMap = {
  'In Progress': 'progress',
  Accepted: 'accepted',
  Rejected: 'rejected',
};
const RA_SUBMIT_TIPS = ['1. Make sure your return item is in its original condition and package the item. ', '2. Download shipping label and secure the label to the outside of your package.'];

// const testDownloadLink = 'https://deliver.goshippo.com/ae4f41c72b654f02bc2d3f35f8961a7a.png?Expires=1692100945&Signature=KBLO00N5t8nPKcmpJNbZm-KjD8PHmWbNNG1dwO4ILKzPk1V2uW8EcTO6XBLRHbZsDAW~zHKnUeN4wPQ9MM5erTav22p24X96~blPNae~KG6pN1-PvnihY6hy-sMV5ydFAS1Qi-zbmytUaNJyYayJr32GGc7JsRBafI5mRCIDBS5T-iMqUd637e3sW2w47EWeuAvhfFHEhhsEpiYL~P3rgiochGW87DnIhCYJz4KakEd21NDV2UmEQAmVYcWuL86CnIKIELO70WRK6hW0ycQokWjejcKn5br6lvKaECT47W1gKaRtXKD4IaUOvAqKX~Ms9q7xxXzckf3sxIQByCL9KQ__&Key-Pair-Id=APKAJRICFXQ2S4YUQRSQ';

export const Feedback = () => {
  const {
    tabIndex, list, detailInfo, isLoading, open, policyId, toggleDrawer, getFeedbackList, onChange, reportIssureClick,
  } = useFeedback();
  // console.log(list, detailInfo, 'info');
  // console.log(isLoading, tabIndex, 'tabIndex');
  const {
    history, items: fulfilledItems, estimatedRefund, issueTypeCode: issueType, attachments, comment, status,
  } = detailInfo;

  const isMobile = isUserMobile();
  const drawerBleeding = 56;
  const timeMap = {
    'Refund via virtual Visa card': 'Processing time: 2 business days',
    'Refund to original payment method': 'Processing time: 5-7 business days',
  };
  useEffectOnce(() => {
    const url = window.location.href;
    // eslint-disable-next-line camelcase
    const { claimId } = queryString.parse(url?.split('?')[1]);
    getFeedbackList(claimId, 0);
  }, []);

  useEffect(() => {
    const script = document.createElement('script');
    if (status) {
      // 添加typeform记录用户反馈
      script.src = '//embed.typeform.com/next/embed.js';
      script.name = 'typeform';
      document.body.appendChild(script);
    }
    return () => {
      script?.remove();
      document.querySelector('.tf-v1-popover')?.remove();
    };
  }, [status]);

  if (isLoading) {
    return <Loading />;
  }
  const TabsPart = ({ claimIdList = [] }) => (
    <Tabs
      orientation="vertical"
      sx={{
        width: isMobile ? '100%' : '300px',
        textTransform: 'none',
        '& .MuiTabs-indicator': {
          display: 'flex',
          backgroundColor: '#645AFF',
          height: '30px !important',
          width: '4px',
          left: 0,
          marginTop: '9px',
        },
        '& .MuiTab-root': {
          textTransform: 'none',
          padding: '8PX 16PX',
        },
      }}
      value={tabIndex}
      onChange={onChange}
    >
      {claimIdList?.map((tab, index) => (
        <Tab
          key={tab.claimId}
          label={(
            <div className={classes.tabItem}>
              {tab.claimId}
              <div className={`${classes.status} ${classes[statusMap[tab.status]]}`}>{tab.status}</div>
            </div>
          )}
          {...a11yProps(index)}
        />
      ))}
    </Tabs>
  );
  // console.log(isMobile, 'isMobile');
  // This is used only for the example
  // const container = window !== undefined ? () => window().document.body : undefined;
  const currentTab = list.find((v) => v.claimId === detailInfo.claimId);
  return (
    <div className={classes.wrapper}>
      {isMobile ? (
        <>
          <div className={classes.mobile_headeer}>
            <div className={classes.tabs_header}>Reported Issues</div>

            <Button
              className={classes.issueButton}
              onClick={reportIssureClick}
            >
              Report an issure

            </Button>
          </div>
          <div onClick={toggleDrawer(true)} className={classes.currentTab_title}>
            <div className={classes.current_item}>
              <span className={classes.current_indicator}></span>
              <span>{currentTab?.claimId}</span>

              <div className={`${classes.status} ${classes[statusMap[currentTab?.status]]}`}>{currentTab?.status}</div>
            </div>
            <ArrowDropDownIcon className={classes.dropdown_icon} />
          </div>

          <SwipeableDrawer
            // container={container}
            anchor="bottom"
            open={open}
            onClose={toggleDrawer(false)}
            onOpen={toggleDrawer(true)}
            swipeAreaWidth={drawerBleeding}
            disableSwipeToOpen={false}
            ModalProps={{
              keepMounted: true,
            }}
            className={classes.drawer_content}
          >
            <div className={classes.drawer_content}>
              <div className={classes.tabs_header}>Reported Issues</div>
              {/* <Typography sx={{ p: 2, color: 'text.secondary' }}>51 results</Typography> */}
              <TabsPart claimIdList={list} />

            </div>

            <Skeleton variant="rectangular" height="100%" />
          </SwipeableDrawer>
        </>
      ) : (
        <>
          <div style={{ width: '351PX', visibility: 'hidden', minWidth: '300PX' }}></div>
          <Stack direction="column" style={{ position: 'fixed', height: '100%' }}>
            <div className={classes.tabs_header}>Reported Issues</div>
            <div className={classes.tab_part}>
              <TabsPart claimIdList={list} />

              <Button
                className={classes.issueButton}
                onClick={reportIssureClick}
              >
                Report an issue

              </Button>
            </div>

          </Stack>
        </>
      )}

      <Stack
        direction="column"
        sx={{
          width: isMobile ? '100%' : '80%',
          alignItems: 'center',
          position: 'realative',
          zIndex: 11,
          paddingRight: !isMobile && '100px',
          textAlign: 'left',
          // minWidth: 600,
        }}
      >
        <div className={classes.card}>
          <div className={classes.detailTitle}>Issue progress</div>
          <Stepper
            // activeStep={1}
            orientation="vertical"
            sx={{
              '& .MuiStepIcon-root': {
                width: '32PX',
                height: '32PX',
                color: '#D4D4D4',
              },
            }}
          >
            {history?.map(({
              done, title, desc, eventTime, downloadLink,
            }) => {
              const showRejectIcon = done && title === 'Rejected';
              return (
                <Step
                  key={title}
                  completed={done}
                  expanded={done}
                  active={done}
                  sx={{
                    '& .MuiStepContent-root, & + .MuiStepConnector-root .MuiStepConnector-line': {
                      borderLeft: `2px solid  ${done ? '#738DED' : '#D5D5D5'}`,
                      paddingLeft: '28px',
                    },
                    '& .MuiStepContent-last': {
                      borderLeft: 'none',
                    },
                    '& .MuiStepIcon-root.Mui-completed': {
                      color: title === 'Accepted' ? '#59CD9E' : '#738DED',
                    },
                  }}
                >
                  <StepLabel
                    StepIconComponent={showRejectIcon ? CloseIcon : null}
                    sx={{
                      '& .MuiSvgIcon-root': showRejectIcon && {
                        color: '#fff',
                        background: '#FFA343',
                        borderRadius: '50%',
                        width: '32PX',
                        height: '32PX',
                      },
                    }}
                  >
                    <div className={classes.stepLabelWrapper}>
                      <span className={classes.stepTitle}>{title}</span>
                      {eventTime && (
                        <span className={classes.stepTime}>
                          {`${eventTime} UTC`}
                        </span>
                      )}

                    </div>

                  </StepLabel>
                  <StepContent
                    sx={{
                      '&': {
                        wordBreak: 'break-word',
                      },
                    }}
                  >
                    {issueType === ClaimType.RA && title === 'Submitted' ? (
                      <div>
                        <div className={classes.ra_submit_title}>Your return request has been submitted, it’s time to ship back the item!</div>
                        <div className={classes.ra_submit}>
                          {RA_SUBMIT_TIPS.map((v) => <div key={v}>{v}</div>)}
                          <div>
                            3. Visit your nearest
                            {' '}
                            <a href="https://tools.usps.com/find-location.htm" target="_blank" rel="noreferrer">USPS location</a>
                            {' '}
                            to drop off your return within
                            {' '}
                            <span className={classes.bold}>3</span>
                            {' '}
                            days or
                            {' '}
                            <a href="https://tools.usps.com/schedule-pickup-steps.htm" target="_blank" rel="noreferrer">schedule a pickup</a>
                            {' '}
                            with USPS.
                          </div>
                        </div>
                        {
                          downloadLink
                          && (
                            <Button
                              sx={{
                                backgroundColor: '#FFFFFF',
                                '&:hover': {
                                  backgroundColor: '#F6F6F7',
                                },
                                '& a': {
                                  color: '#fff',
                                  textDecoration: 'none',
                                  padding: '2px 8px',
                                },
                              }}
                              className={classes.shippingLabelBtn}
                            // onClick={() => download(testDownloadLink)}
                            >
                              {/* Download shipping label */}
                              <a href={downloadLink} target="_blank" rel="noopener noreferrer" download>Download shipping label</a>
                            </Button>
                          )
                        }

                      </div>
                    )
                      // eslint-disable-next-line react/no-danger
                      : <div className={classes.stepContent} dangerouslySetInnerHTML={{ __html: desc }}></div>}
                  </StepContent>
                </Step>
              );
            })}
          </Stepper>

        </div>
        {issueType === ClaimType.RA
          ? <RAReviewPanel reviewInfo={{ ...estimatedRefund, payment: { time: timeMap[estimatedRefund.resolution], title: estimatedRefund.resolution } }} />
          : (
            <BPReviewPanel
              reviewInfo={estimatedRefund}
            />
          )}
        <ReviewItemList
          selectedPackageList={fulfilledItems}
          files={attachments?.map((item) => ({ name: item.originalFileName }))}
          type={issueType}
          comments={comment}
        />
        <div className={classes.bottomMark}>
          <span>Having questions? Contact us at </span>
          <SeelEmail style={{ fontSize: '14px', lineHeight: '20px' }} />

        </div>
      </Stack>
      {/* 添加typeform记录用户反馈  https://seel.atlassian.net/browse/OP-2205 */}
      <div id="typeform" data-tf-popover="JIXHLspS" data-tf-custom-icon="https://images.typeform.com/images/zBPgAKMtjwxA" data-tf-opacity="100" data-tf-iframe-props="title=Share your valuable feedback and help us improve!" data-tf-open="time" data-tf-open-value="3000" data-tf-auto-close data-tf-transitive-search-params data-tf-button-color="#645AFF" data-tf-tooltip="Share your valuable feedback and help us improve!" data-tf-medium="snippet" data-tf-hidden={`utm_content=${policyId}`} style={{ all: 'unset' }}></div>

    </div>
  );
};
